import {CartItem, Payload} from "modules/cart/types/cart"

export const get_total_qty_per_prod = (id:string,cart:CartItem[]):number => {
    const item = cart.find((i) => i.id === id);
    if (!item) return 0;
    return item.price_component.reduce((acc, pc) => acc + pc.quantity, 0);
}

export const getTotalQty = (cart:CartItem[]):number => {
    return cart.reduce((acc, mp)=>{
        const pcQty = mp.price_component.reduce((suAcc,pc) => suAcc+pc.quantity, 0);
        return acc + pcQty;
    },0);
}

export const getTotalAmountPerProduct = (product:CartItem):number => {
    return product.price_component.reduce((acc,pc)=>acc + pc.price, 0);
}


export const getTotalAmount = (cart:CartItem[]):number => {
    return cart.reduce((acc, mp)=>{
        const pcSum = mp.price_component.reduce((suAcc,pc) => suAcc+pc.price, 0);
        return acc + pcSum;
    },0);
}

export const compareCartContents = (cart1: CartItem[], cart2: CartItem[]): boolean => {
    // Si tienen diferente cantidad de elementos, ya son diferentes
    if (cart1.length !== cart2.length) return false;
    // Crear mapas para facilitar la búsqueda
    const cart1Map = createCartMap(cart1);
    const cart2Map = createCartMap(cart2);
    
    // Verificar que cada producto tenga las mismas cantidades
    for (const [productId, product1Info] of Object.entries(cart1Map)) {
        // Verificar si el producto existe en el segundo carrito
        if (!cart2Map[productId]) return false;
        const product2Info = cart2Map[productId];
        
        // Verificar que tengan la misma cantidad total
        if (product1Info.totalQuantity !== product2Info.totalQuantity) return false;
        // Verificar componentes de precio
        if (product1Info.priceComponents.length !== product2Info.priceComponents.length) return false;
        // Comparar cada componente de precio
        for (let i = 0; i < product1Info.priceComponents.length; i++) {
            if (product1Info.priceComponents[i].quantity !== product2Info.priceComponents[i].quantity ||
                product1Info.priceComponents[i].id !== product2Info.priceComponents[i].id) {

                return false;
                
            }
            
        }
    }
    return true;
};

// Función para crear un mapa de productos por ID con sus cantidades
const createCartMap = (cart: CartItem[]) => {
    const cartMap: Record<string, {
        totalQuantity: number,
        priceComponents: { id: number, quantity: number }[]
    }> = {};
    
    for (const item of cart) {
        cartMap[item.id] = {
            totalQuantity: get_total_qty_per_prod(item.id, cart),
            priceComponents: item.price_component.map(pc => ({
                id: pc.id,
                quantity: pc.quantity
            }))
        };
    }
    
    return cartMap;
};


export const addDeletefromCartOptimized = (cart:CartItem[], payload:Payload):CartItem[] => {
    const currIndex = cart.findIndex((item:CartItem) => item.id === payload?.id);

    if (currIndex >= 0) {
        // Si el producto existe, actualizarlo
        const existingItem = cart[currIndex];
        const updatedItem: CartItem = {
            ...existingItem,
            // Actualizar con los datos del payload si existen
            ...(payload.name && { name: payload.name }),
            ...(payload.sku && { sku: payload.sku }),
            // Actualizar price_component[0] con la nueva cantidad
            price_component: existingItem.price_component.map((pc, index) => 
                index === 0 
                    ? { ...pc, quantity: payload.quantity || 0 }
                    : pc
            )
        };

        // Calcular cantidad total para decidir si eliminar o actualizar
        const total_qty = updatedItem.price_component.reduce((acc, pc) => acc + pc.quantity, 0);
        
        if (total_qty <= 0) {
            // Eliminar producto del carrito
            return [
                ...cart.slice(0, currIndex),
                ...cart.slice(currIndex + 1)
            ];
        } else {
            // Actualizar producto en el carrito
            return [
                ...cart.slice(0, currIndex),
                updatedItem,
                ...cart.slice(currIndex + 1)
            ];
        }
    } else {
        // Si no existe, es un error crítico
        const error = new Error(`Producto con ID ${payload?.id} no encontrado en el carrito`);
        
        // Emitir error para Sentry
        throw error;
    }
}



